import { Card, CardContent } from '@/components/shadcn/card';
import Image from 'next/image';
import Link from 'next/link';

interface NewsCardProps {
  image?: string;
  imageAlt?: string;
  category?: string;
  title: string;
  href: string;
  readMore?: string;
}

export default function NewsCard({ image, imageAlt, category, title, href, readMore = "Read More" }: NewsCardProps) {
  return (
    <Card className="flex flex-col sm:flex-row sm:items-center border-0 border-t border-[#D0D5DD] rounded-none p-4 sm:p-6 gap-4 sm:gap-6 shadow-none bg-transparent">
      <div className="flex-shrink-0 w-full sm:w-[180px] h-[180px] sm:h-[120px]">
        {image ? (
          <Image
            src={image}
            alt={imageAlt || title}
            width={180}
            height={120}
            className="rounded-lg object-cover w-full sm:w-[180px] h-[180px] sm:h-[120px]"
          />
        ) : (
          <div className="rounded-lg bg-gray-200 w-full sm:w-[180px] h-[180px] sm:h-[120px]" />
        )}
      </div>
      <CardContent className="flex flex-col justify-start px-0 py-0 h-full">
        <span className="text-base text-[#0C2340] opacity-70 mb-2">
          {category ? category : <span className="inline-block w-24 h-4 bg-gray-200 rounded" />}
        </span>
        <span className="block text-[20px] font-bold text-[#0C2340] leading-snug mb-4 ellipsis">
          {title || <span className="inline-block w-48 h-5 bg-gray-200 rounded" />}
        </span>
        <Link
          href={href}
          aria-label={`${readMore}: ${title}`}
          className="text-[#094CAD] text-md font-semibold underline underline-offset-2 hover:text-blue-800 w-fit"
        >
          {readMore}
        </Link>
      </CardContent>
    </Card>
  );
}
